angular.module 'zc.commonApi'
.service 'campaignStatuses', ($filter) ->
  return {
    incomplete:
      text: $filter('translate')('sharedModules.commonApi.misc.campaignStatuses.incomplete')
      statusClass: 'label status-notset'
    preview:
      text: $filter('translate')('sharedModules.commonApi.misc.campaignStatuses.preview')
      statusClass: 'label status-waiting'
    active:
      text: $filter('translate')('sharedModules.commonApi.misc.campaignStatuses.active')
      statusClass: 'label status-active'
    finished:
      text: $filter('translate')('sharedModules.commonApi.misc.campaignStatuses.finished')
      statusClass: 'label status-finished'
    terminated:
      text: $filter('translate')('sharedModules.commonApi.misc.campaignStatuses.terminated')
      statusClass: 'label status-finished'
    pending:
      text: $filter('translate')('sharedModules.commonApi.misc.campaignStatuses.pending')
      statusClass: 'label status-waiting'
    no_incentives:
      text: $filter('translate')('sharedModules.commonApi.misc.campaignStatuses.no_incentives')
      statusClass: 'label status-waiting'
    blocked:
      text: $filter('translate')('sharedModules.commonApi.misc.campaignStatuses.blocked')
      statusClass: 'label status-stop'
  }



// WEBPACK FOOTER //
// ../app_shared/src/shared_modules/common_api/misc/campaign_statuses.constant.coffee